export const APPEND_EVENT_SUCCESS = 'events/APPEND_EVENT_SUCCESS';
export const FETCH_EVENTS_REQUEST = 'events/FETCH_EVENTS_REQUEST';
export const FETCH_EVENTS_SUCCESS = 'events/FETCH_EVENTS_SUCCESS';
export const FETCH_EVENTS_FAILURE = 'events/FETCH_EVENTS_FAILURE';
export const DISPLAY_GLOBAL_EVENT = 'events/DISPLAY_GLOBAL_EVENT';
export const PUSH_GLOBAL_EVENT = "events/PUSH_GLOBAL_EVENT";
export const SET_CURRENT_EVENT = "events/SET_CURRENT_EVENT";
export const UNSET_CURRENT_EVENT = "events/UNSET_CURRENT_EVENT";
export const MUTE_EVENTS = 'events/MUTE_EVENTS';
